/**
 * Print given HTML using a hidden iframe.
 */
export const printHTML = html => {
  const frame = document.createElement('iframe');
  frame.name = 'frame1';
  frame.style.position = 'absolute';
  frame.style.top = '-10000px';
  document.body.appendChild(frame);

  const frameDoc =
    frame.contentWindow ||
    frame.contentDocument.document ||
    frame.contentDocument;
  frameDoc.document.open();
  frameDoc.document.write('<html>');
  frameDoc.document.write('<body onload="this.focus(); this.print();">');
  frameDoc.document.write(html);
  frameDoc.document.write('</body></html>');
  frameDoc.document.close();
};

export const printPDF = async url => {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(
    new Blob([blob], { type: 'application/pdf' }),
  );
  const newWindow = window.open(blobUrl, '_blank');
  newWindow.focus();
  // Add set timeout due to Safari browser execute print command before load
  setTimeout(() => {
    newWindow.print();
  }, 500);
};
